<template>
  <v-container grid-list-xs ma-0 pa-0 fluid>
    <slot :args="args" :data="data" :loading="loading">
      {{data}}
    </slot>
  </v-container>
</template>

<style scoped>

</style>

<script>
  import GhDynamicInvoke from "./ghDynamicInvoke.ts";
  export default GhDynamicInvoke;
</script>